import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import {MatDialogModule} from '@angular/material/dialog';
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder, } from '@angular/forms';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import * as _moment from 'moment';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { UserMultiColumnDropdownComponent } from '../user-multi-column-dropdown/user-multi-column-dropdown.component';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { element } from 'protractor';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { constants } from 'src/app/shared/common/contants';
import { VaultObjectgroupService } from '../vaultobject-popup-screen/vault-objectgroup.service';
import { VaultobjectattributedialogComponent } from '../vaultobjectattributedialog/vaultobjectattributedialog.component';
import { TrnxchildBaseScreenComponent } from '../trnxchild-base-screen/trnxchild-base-screen.component';
import { MultipleobjectextractionserviceService } from './multipleobjectextractionservice.service';
import {CommonService} from '../../shared/services/common.service';
import { UserRoutingModule } from 'src/app/user/user-routing/user-routing.module';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole'

const moment =  _moment;

@Component({
    selector: 'app-multipleobjectsextraction',
    templateUrl: './multipleobjectsextraction.component.html',
    styleUrls: ['./multipleobjectsextraction.component.scss'],
    standalone: false
})
export class MultipleobjectsextractionComponent implements OnInit {

 extraction=[{"objectattributesid":"","name": "","datasetobjectattributes":null,"databasename":"","objectid":"","extractionType" :"MultiObjectExtraction"}]
  validation_messages;
  components: any;
  validations_form: UntypedFormGroup;
  butttonname;
  columnDefsForObjects;
  columnDefsForTablesFields;
  columnDefsForSelectedFields;
  columnDefs;
  defaultColDef;
  rowSelectionForTablesFields;
  rowSelection;
  backgroundColorScreen;
  buttonColor;
  vaultGroup:any=[];
  groups:any=[];
  ObjectGrid;
  paramstemp;
  ObjectsData:any=[];
  selectedTableFields;
  selectedFieldsDataToPush: any = [];
  tableFields = [];
  fieldsData=[];
  selectedFieldsData;
  tablefields:any=[];
  gridApiForTablesFields;
  allFields: any = [];
  selectedObject;
  columnDefsForReportingConfiguration;
  show: boolean = false;
 expand:boolean = false;
 fieldsDataToRemove: any;
 selectObjectId;
 temp: any = [];
 isExpand: boolean = true;
 databases:any;
 eachdatabase;
 value;
 ngModelObjectTemporary;
 gridApi;
 lastpage;
 currentpage;
 nextpage;
 nextpageplusone;
 totalpages;
 pageSize
 names:any = [];
 objectsgroupData:any = [];
 namesData:any = [];
 dnsname:any;
 dnsData:any;
 method;
 vaultObject:any;
 selectedAttributes:any;
 selectedVaultObjects:any;
 vaultObjects:any=[];
 attributes:any=[];
 pagesize
 rowClassRules
 paginationPageSize
 paginationNumberFormatter
 methodtype = "insert";
 type
 extractName;
 databasename;
 updatedObject:any=[];
 responserequest;


 constructor(private msg: ErrorMessages, private validation: validationmethod, private service: ReportingServiceService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private dialog: MatDialog, private fb: UntypedFormBuilder, private localStorageSettings: LocalStorageSettingsService, private formFieldsTrimer: FormFieldsTrimer,private linkservice: ReportlinksserviceService,private constants: constants,private extractService:MultipleobjectextractionserviceService,private retrieveScreenAccess: RetrieveScreenAccess,private userRoutingModule: UserRoutingModule) {
   //messages for validations
   this.validation_messages = this.msg.objectattributes;
   //cell rendering in ag-grid
   this.components = {
     buttonRenderer: Actionbutton,
   }
 }
 formValidation() {
   this.validations_form = new UntypedFormGroup({
     name: new UntypedFormControl(this.extractName, [Validators.required, Validators.maxLength(100)]),
     databasename: new UntypedFormControl(this.databasename, [Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100)])
   });
 }

 ngOnInit() {

  this.linkservice.fetchUserRole(this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(res => {
    console.log(res);
    this.responserequest = res;
  });

  /* modified by Chandra R
     *  calling the Userroles method to assign the rolenames for IDs in gride
     *  30-06-2024
  */
  let screenPath = this.userRoutingModule.print(this.constructor.name);
  this.retrieveScreenAccess.find(screenPath);
  this.linkservice.screenoperationspermission(screenPath, this.localStorageSettings.getSettings('UserId')).subscribe(res => {
    console.log(res);
    const buttonIdList: number[] = [];
    let responsedata: any;
    responsedata = res;
    for (let i = 0; i < responsedata.length; i++) {

      buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
    }

    console.log('Button ID List:', buttonIdList);
    const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
    buttons.forEach(button => {
      const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
      if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
        if (!buttonIdList.includes(buttonId)) {
          button.setAttribute('disabled', 'true'); // Disable the button
        } else {
          button.removeAttribute('disabled'); // Enable the button
        }
      }
   

      
    });
  });

  this.defaultExtractionName();
   this.formValidation();


   this.butttonname = "Save";

   this.columnDefsForObjects = [
     {
       headerName: "Vault Objects",
       headerTooltip: "Vault Objects",
       tooltipValueGetter: params => "Vault Objects : " + params.value,
       field: "objectlabel",
       filter: "agTextColumnFilter",
       width: 400,
       headerCheckboxSelectionFilteredOnly: true,
       checkboxSelection: false,
       sort:'asc',
       animateRows: true,
     }
   ];


   this.columnDefsForSelectedFields = [
    {
      headerName: "Selected Objects",
      headerTooltip: "Selected Objects",
      tooltipValueGetter: params => "Selected Attributes : " + params.value,
      field: "attributeNameWithFields",
      filter: "agTextColumnFilter",
      width: 400,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: false,
      sort:'asc',
      cellStyle: { " padding-left": "5px" }
    }
  ];

   this.columnDefs = [
     { headerName: 'Extraction Name', headerTooltip: 'Extraction Name', tooltipValueGetter: (params) => 'Extraction Name : ' + params.value, field: 'name', filter: 'agTextColumnFilter', width: 200, },
     { headerName: 'Database Name', headerTooltip: 'Database Name', tooltipValueGetter: (params) => 'Database Name : ' + params.value, field: 'databasename', filter: 'agTextColumnFilter', width: 200 },
     { headerName: 'Object Name', headerTooltip: 'Object Name', tooltipValueGetter: (params) => 'Object Name : ' + params.value, field: 'objectlabel', filter: 'agTextColumnFilter', width: 200 },
     { headerName: 'Username', headerTooltip: 'Username', tooltipValueGetter: (params) => 'Username : ' + params.value, field: 'username', filter: 'agTextColumnFilter', width: 200 },
     { headerName: 'Activity Name', headerTooltip: 'Activity Name', tooltipValueGetter: (params) => 'Activity Name : ' + params.value, field: 'activityname', filter: 'agTextColumnFilter', width: 150 },
     { headerName: 'Start Date and Time', headerTooltip: 'Start Date and Time', tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value, field: 'servicestartdatetime', filter: 'agTextColumnFilter', width: 150 },
     { headerName: 'End Date and Time', headerTooltip: 'End Date and Time', tooltipValueGetter: (params) => 'End Date and Time : ' + params.value, field: 'serviceenddatetime', filter: 'agTextColumnFilter', width: 150 },
     { headerName: 'Service Start Status', headerTooltip: 'Service Start Status', tooltipValueGetter: (params) => 'Service Start Status : ' + params.value, field: 'servicestartstatus', filter: 'agTextColumnFilter', width: 150 },
     { headerName: 'Service End Status', headerTooltip: 'Service End Status', tooltipValueGetter: (params) => 'Service End Status : ' + params.value, field: 'serviceendstatus', filter: 'agTextColumnFilter', width: 150 },
     { headerName: 'Exception', headerTooltip: 'Exception', tooltipValueGetter: (params) => 'Exception : ' + params.value, field: 'exception', filter: 'agTextColumnFilter', width: 150 },
   ]
   // below object is resizable, sorting and filter for ag-grid
   this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
     sortable: true,
     resizable: true,
     filter: true
   };


   this.rowSelectionForTablesFields='multiple';
   this.rowSelection = 'multiple';

   this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
   this.buttonColor = this.localStorageSettings.getSettings("ColorA");

  // this.lookupVaultGroup();
   this.databasenames();
   this.insertednames();
 }

 insertednames(){
  this.extractService.insertedname().subscribe(res =>{
    console.log(res);
    this.names = res;
    let uniq
    this.names.filter(obj => !uniq[obj.name] && (uniq[obj.name] = true));
  });
}

 defaultExtractionName(){
   let currentdateandtime = moment().format("DDMMYYYY_hhmmss")
   console.log(currentdateandtime)
   this.extractName = currentdateandtime
 }



 //Pagination code below
 onPaginationChanged() {
   if (this.gridApi) {

     this.lastpage = this.gridApi.api.paginationIsLastPageFound();

     this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1

     this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1

     this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1

     this.totalpages = this.gridApi.api.paginationGetTotalPages()

   }

 }

 //this function is for going to the given page number
 onSearchChange(searchValue: number) {

   this.gridApi.api.paginationGoToPage(searchValue - 1);

 }

 // below function is for changing the no of rows per page
 onPageSizeChanged(newPageSize) {

   var value = this.pageSize;

   this.gridApi.api.setGridOption('paginationPageSize', Number(value));

 }

 // below function is for going to next page
 async onBtNext() {

   /*this.recordsStart = this.recordsStart + 100;

   this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

   console.log(this.retrieveObject);

   if (this.retrieveObject.length == 0) {

     this.recordsStart = this.recordsStart - 100;

   }

   else {

     this.gridAPI.setGridOption('rowData', this.retrieveObject);

   }*/

   this.gridApi.api.paginationGoToNextPage();

 }

 // below function for going to previous page
 async onBtPrevious() {

   /*if (this.recordsStart > 0) {

     this.recordsStart = this.recordsStart - 100;

     this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

     console.log(this.retrieveObject);

     this.gridAPI.setGridOption('rowData', this.retrieveObject);

   }*/

   this.gridApi.api.paginationGoToPreviousPage();

 }

 // below function for going to first page
 onBtFirst() {

   this.gridApi.api.paginationGoToFirstPage();

 }

 // below function for going to last page
 onBtLast() {

   this.gridApi.api.paginationGoToLastPage();

 }
 //pagination code ends

 onGridReady(params){
   this.gridApi = params;
   this.extractService.retrieveobjectattributes(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {

     this.spinner.start();

     console.log(res);

     // checking if response is true or not
     if (res.error === true) {

       this.spinner.stop();

       this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });

       this.gridApi.api.setGridOption('rowData', []);

     } else {

       this.spinner.stop();

       this.ObjectsData=res;

       this.gridApi.api.setGridOption('rowData', this.ObjectsData);

     }

   });
 }

 refresh(){
   this.onGridReady(this.gridApi)
   this.insertednames();
 }



 cellClickedObjects(e){
  this.fieldsData = this.ObjectGrid.api.getSelectedRows();

  this.selectedFieldsData = this.fieldsData;

  console.log(this.selectedFieldsData);
  console.log(this.temp.length)
  if(this.selectedFieldsData.length>10 || this.temp.length>=10){
    this.selectedFieldsData=[];
    this.snackbar.open("Only 10 Objects allowed","Ok",{duration:5000})
  }

 }


 onGridReadyForSelectedTableFields(params, tableName) {
  this.selectedTableFields=params
  //this.gridApiForTablesFields = params.api;
  console.log(this.selectedTableFields)
  this.selectedTableFields.api.setGridOption('rowData', []);
  this.selectedTableFields.api.setGridOption('rowData', tableName);
  //this.fieldsData = this.selectedTableFields.api.getSelectedRows();

}


//forward Icon Function decleation
pushDataToSelectedFieldsGrid() {
  this.fieldsDataToRemove=[];
  // this.selectedFieldsDataToPush = [];
  this.temp = [];
  let uniq = {}
  console.log(this.selectedFieldsData);
  for (let i = 0; i < this.selectedFieldsData.length; i++) {
    this.selectedFieldsData[i].objectId = this.selectObjectId;
    this.selectedFieldsData[i].object = this.selectedObject;
    this.selectedFieldsData[i].attributeNameWithFields = this.selectedFieldsData[i].objectlabel
    this.selectedFieldsDataToPush.push(this.selectedFieldsData[i]);
    this.vaultObjects.filter(eachObject=>{
      if(eachObject.objectlabel === this.selectedFieldsData[i].objectlabel){
        console.log("matched")
        this.selectedFieldsData[i].tempindex = this.vaultObjects.indexOf(eachObject);
        this.vaultObjects.splice(this.selectedFieldsData[i].tempindex,1);
      }
    })
  }
  console.log(this.vaultObjects)
  console.log(this.selectedFieldsDataToPush)
  //duplicates data not allowed
  this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
  console.log(this.temp)
  this.ObjectGrid.api.setGridOption('rowData', this.vaultObjects);
  this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
  //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
}

//backward Icon Function decleation
popDataToSelectedFieldsGrid() {
  this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
  console.log(this.temp)
  this.fieldsDataToRemove.filter(eachremove=>{
    this.vaultObjects.splice(eachremove.tempindex, 0,eachremove);
    this.ObjectGrid.api.setGridOption('rowData', this.vaultObjects);
    })
  this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
  //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
  this.selectedFieldsDataToPush = this.temp.filter(item =>!this.fieldsDataToRemove.includes(item));
  this.fieldsDataToRemove=null


}

onRowSelectedToRemove(ev) {
  console.log(ev);
  this.fieldsDataToRemove = this.selectedTableFields.api.getSelectedRows();
  console.log(this.fieldsDataToRemove);
}


 async onGridReadyForObjects(params,check) {
   this.ObjectGrid=params;
   //retrieve objectlabel by dnsid
   var dnsId = localStorage.getItem("dnsName")
   this.extractService.retrieveobjectlabels().subscribe(res => {
     console.log(res);
     this.vaultObjects=res;
     if(res.error == true){
       this.ObjectGrid.api.setGridOption('rowData', []);
     }else{
       this.ObjectGrid.api.setGridOption('rowData', this.vaultObjects);
       if(check==="update"){
         this.objectcheck();
       }
     }
   });

 }

   cancel() {
     console.log(this.show)
     this.tablefields =[];
     this.columnDefsForReportingConfiguration = [];
     this.formValidation();
     this.selectedTableFields.api.setGridOption('rowData', []);
     this.ObjectGrid.api.forEachNode(node=> {
         node.setSelected(false);
     });
     this.selectedFieldsDataToPush = [];
     this.selectedFieldsData=[];
     this.temp=[];
     this.fieldsData=[];
     this.onGridReadyForObjects(this.ObjectGrid,"insert");
     this.defaultExtractionName();
   }

   openSaveForm(){
     this.expand=true
     this.show=true
   }



 cellClickedFields(e){
   console.log(e)
 }

 onselection(params){
   console.log(params)
 }

 async nameSelection(e){
   this.updatedObject=[]
  let uniq = {}
  console.log(e.value)
  // this.namesData=[]
  this.extractService. retrieveInsertData(e.value).subscribe(res =>{
    this.spinner.start()
    console.log(res);
    this.namesData=res;
    console.log(this.namesData);
    this.updatedObject = this.namesData.filter(obj => !uniq[obj.objectattributesid] && (uniq[obj.objectattributesid] = true));
    this.onGridReadyForObjects(this.ObjectGrid,"update");
});
}

objectcheck(){
  console.log(this.ObjectGrid)
  console.log(this.updatedObject)
  for(let k=0; k<this.updatedObject.length; k++){
    console.log(this.updatedObject[k]);
    this.vaultObjects.filter(eachObject=>{
      if(eachObject.objectlabel === this.updatedObject[k].objectlabel){
        this.updatedObject[k].id = eachObject.id;
        console.log("matched");
        this.vaultObjects.splice(this.vaultObjects.indexOf(eachObject),1);
      }
    })
  }
  //   this.ObjectGrid.api.forEachNode(node=> {
  //   console.log(node.data.objectlabel)
  //   console.log(node.data.id)
  //   console.log(node.data.objectattributesid)
  //   if(node.data.objectlabel===this.namesData[k].objectlabel){
  //     this.namesData[k].id = node.data.id;
  //     node.setSelected(true);
  //   }
  //   console.log(this.namesData)
  // });
console.log(this.vaultObjects)
this.ObjectGrid.api.setGridOption('rowData', this.vaultObjects);
this.spinner.stop()
this.attributesmapping();
}

attributesmapping(){
  console.log(this.updatedObject)
  let uniq = {}
  this.temp=[];
  this.selectedFieldsDataToPush = [];
    for (let i = 0; i < this.updatedObject.length; i++) {
      let selectobjects={"objectattributesid":"","id":"","attributeNameWithFields":"","objectlabel":""};
      selectobjects.objectattributesid = this.updatedObject[i].objectattributesid;
      selectobjects.id = this.updatedObject[i].id;
      selectobjects.objectlabel = this.updatedObject[i].objectlabel;
      selectobjects.attributeNameWithFields = this.updatedObject[i].objectlabel;
      this.selectedFieldsDataToPush.push(selectobjects);
    }
  console.log(this.selectedFieldsDataToPush)
  //duplicates data not allowed
  this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.objectattributesid] && (uniq[obj.objectattributesid] = true));
  this.method="update";
  console.log(this.temp)
  this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
}


addname(){
  this.namesData=[];
  this.cancel();
  var object = {
    name: ""
  };
  let dialogRef = this.dialog.open(VaultobjectattributedialogComponent, {
    maxWidth: '100vw',
    width: '60%',
    data: { ename: object },
    disableClose: true
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log(result);
    var isDuplicate = false;
      //remove drop down duplicates entry
      for (let i = 0; i < this.names.length; i++) {
        console.log(this.names[i].toLowerCase());
        console.log(result.name.toLowerCase());
        if (
          this.names[i].toLowerCase() ==
          result.name.toLowerCase()
        ) {
          isDuplicate = true;
        }
      }
      if (isDuplicate) {
        alert(result.name + " is duplicate entry");
      }
    if (!isDuplicate) {
      var data = {
        name: result.name
      };
      this.names.push(result.name);
      this.extractName = result.name;
      this.method= "insert";
    }
  });
  console.log(this.extractName);
}


 createreport(){
  let uniq = {}
  this.extraction=[];
   console.log(this.extractName)
   //console.log(this.objectattributes[0].objectid);
   //this.objectattributes.objectid = this.objectsgroupData.objectid
  // console.log(this.objectattributes)
  console.log(this.temp.length)
  if(this.temp.length>10){
    this.snackbar.open("Only 10 Objects allowed","Ok",{duration:5000})
    return;
  }else if(this.temp.length ===0){
    this.snackbar.open("Please add atleast one object into select objects","Ok",{duration:5000})
    return;
  }
   console.log(this.selectedFieldsDataToPush)
   this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.id] && (uniq[obj.id] = true));

   for(let i=0;i<this.temp.length;i++){

  let fulldataextraction={"objectattributesid":"","name": "","datasetobjectattributes":null,"databasename":"","objectid":"","extractionType" :"MultiObjectExtraction","dnsId":""}
     console.log(fulldataextraction)
     fulldataextraction.name = this.extractName;
     fulldataextraction.objectid = this.temp[i].id;
     fulldataextraction.databasename = this.databasename;
     fulldataextraction.datasetobjectattributes = null;
     fulldataextraction.extractionType ="MultiObjectExtraction";
     fulldataextraction.objectattributesid = this.temp[i].objectattributesid;
     fulldataextraction.dnsId = this.localStorageSettings.getSettings("dnsName");
     this.extraction.push(fulldataextraction);
   }
   console.log(this.extraction)

   if (!this.validations_form.valid) {
     // displaying validation messages
     this.validation.validateAllFormFields(this.validations_form);
     this.validation.getvalidationmessage();
     return
   }

   else {
   this.extractService.insertobjectattributes(this.extraction,this.method,localStorage.getItem("vaultDnsname")).subscribe(response=>{
     this.spinner.start();
     console.log(response);
     // checking if response is true or not
     if (response.error == true) {
       this.snackbar.open(response.statusMessage, "OK", {
         duration: 5000,
       });

     } else {
       this.snackbar.open(response.statusMessage, "OK", {
         duration: 5000,
       });
       this.defaultExtractionName();
     }
     this.spinner.stop();
     this.cancel();
   });
 }
}





 databasenames(){
   this.dnsname = this.localStorageSettings.getSettings("dnsName");
   console.log(this.dnsname);
   let dnsNames = this.dnsname
   this.extractService.databasename(dnsNames).subscribe(res=>{
     console.log(res)
     this.dnsData = res;
     console.log(this.dnsData);
     console.log(this.dnsData[0].databasename);
     this.databasename = this.dnsData[0].databasename;
   });
 }
}

